/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gender__O1Inputs */

const en_gender__o1 = /** @type {(inputs: Gender__O1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other / Unspecified`)
};

/**
* | output |
* | --- |
* | "Other / Unspecified" |
*
* @param {Gender__O1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const gender__o1 = /** @type {((inputs?: Gender__O1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gender__O1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_gender__o1(inputs)
});
export { gender__o1 as "gender__O" }